import { render, staticRenderFns } from "./gift-note-status.vue?vue&type=template&id=61157eec&"
import script from "./gift-note-status.vue?vue&type=script&lang=js&"
export * from "./gift-note-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports